<div class="modal__header">
	<h2 class="title" id="modal__title">{{ 'header.text.logIn' | ibeadmin | async }}</h2>
	<div class="modal__header-actions" *ngIf="!hideClose">
		<button aria-label="Close dialog" (click)="cancel()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body login-body sl--scrollable">
	<div class="login-content" aria-label="Login section" tabindex="0">
		<app-notification *ngIf="(this.loginErrorMessage && !loginErrorPasswordRelated && !loginErrorUsernameRelated) || INDRA_serviceError()"
			[style]="'note'" [icon]="'icons.svg#general--information'" [title]="INDRA_errorTitle()">
			<div message>
				<span>{{ INDRA_getLoginErrorMessage() | ibeadmin:'sync' }}</span>
			</div>
		</app-notification>
		<form class="login-content__form" [formGroup]="form">
			<div class="large-input__wrapper form-field" *ngIf="account===''; else userName">
				<div class="large-input" *ngIf="!isCorporate" [ngClass]="INDRA_printStyle('username')">
					<div class="large-input__text">
						<label class="large-input__label" for="login">{{ 'header.text.emailCustomerNumber' | ibeadmin:'sync' }}</label>
						<div class="large-input__input-wrapper">
							<input 
								name="Email or Customer Number" 
								id="login" 
								class="large-input__input"
								[ngClass]="{ invalidated: isInvalid('login') || loginErrorUsernameRelated }"
								placeholder="" 
								formControlName="login"
								[readonly]="account!=''"
								(focus)="INDRA_handleFocus($event)"
								(blur)="INDRA_handleBlur($event)"
							/>
						</div>
					</div>
				</div>
				<div 
					*ngIf="loginErrorUsernameRelated "
					class="form-errors near-input">
					{{ this.loginErrorMessage | ibeadmin:'sync' }}
				</div>
				<div
					[attr.aria-label]="getLoginFieldError() | ibeadmin: 'sync'"
					*ngIf="isInvalid('login')"
					class="form-errors near-input">
					{{ getLoginFieldError() | ibeadmin:'sync' }}
				</div>
			</div>
			<ng-template #userName>
				<div class="form-field" style="margin-top: -20px;">
					<label *ngIf="!isCorporate" class="label">{{ 'header.text.emailCustomerNumber' | ibeadmin:'sync' }}</label>
					<!-- <label *ngIf="isCorporate" class="label">{{TAP_getLabel()}}</label> -->
					<span>{{account}}</span>
				</div>
			</ng-template>

			<div class="large-input__wrapper form-field">
				<div class="large-input" [ngClass]="INDRA_printStyle('password')">
					<div class="large-input__text" id="password_wrapper">
						<label class="large-input__label" for="login-password">{{ 'header.text.password' | ibeadmin:'sync' }}</label>
						<div class="large-input__input-wrapper">
							<input 
								class="large-input__input" 
								id="login-password" 
								name="Login password" 
								[attr.type]="getPasswordInputType()"
								[ngClass]="{ invalidated: isInvalid('password') || loginErrorPasswordRelated }"
								formControlName="password" 
								maxlength="32"
								(focus)="INDRA_handleFocus($event)"
								(blur)="INDRA_handleBlur($event)"
							/>

							<lottie-animation-view
								class="input-show-hide-icon"
								[ngClass]="{ 'is-show': !passwordIsHidden }"
								[attr.aria-label]="getPasswordInputAriaLabel()"
								role="button"
								tabindex="0"
								[options]="lottieConfig"
								(animCreated)="handleShowHideAnimation($event)"
								(click)="animateShowHidePassword()">
							</lottie-animation-view>
						</div>
					</div>
				</div>

				<div 
					*ngIf="isInvalid('password')" 
					class="form-errors near-input" 
					[attr.aria-label]="('login.passwordRequiredOrInvalid' | ibeadmin: 'sync')"
					tabindex="0">
					{{ 'header.login.passwordRequiredOrInvalid' | ibeadmin: 'sync' }}
				</div>
			</div>
			<div 
				[attr.aria-label]="(loginErrorMessage | ibeadmin:'sync') + ' ' + ((invalidAttempts) ? invalidAttempts : '')" 
				*ngIf="loginError && loginErrorPasswordRelated" 
				style="max-width: fit-content;" 
				class="form-errors near-input">
					{{this.loginErrorMessage | ibeadmin:'sync'}} {{(invalidAttempts) ? invalidAttempts : ''}} 
			</div>
			<div class="form-field">
				<app-checkbox-input label="{{ 'header.text.rememberMe' | ibeadmin | async }}" [id]="'rememberMe'"></app-checkbox-input>
			</div>
			<div class="login-content__recovery">
				{{ 'header.text.recover' | ibeadmin | async }} 
				<a (click)="INDRA_gotoURL()" 
					class="text-link link--external" 
					href="javascript:;" 
					target="_blank" 
					aria-label="Recover password on a new page">
					{{ 'header.text.password' | ibeadmin | async }}
				</a> 
				or 
				<a class="text-link link--external" 
					href="javascript:;"
					*ngIf="!isCorporate"
					(click)="INDRA_recoverTP()"
					aria-label="Recover TP Number on a new dialog">
					{{ 'header.text.tpNumber' | ibeadmin | async }}
				</a>
				<a class="text-link link--external"
					href="https://www.tapcorporate.com/en-pt/login/login/recover-username" 
					*ngIf="isCorporate" 
					target="_blank" 
					aria-label="Recover Username">
					Username
				</a>
			</div>
			<button class="login-action button" type="submit" (click)="INDRA_submitLogin()" *ngIf="!infoLoading">
				{{ 'header.text.logIn' | ibeadmin | async }}
			</button>
			<div *ngIf="infoLoading" class="form-field">
				<app-loading-circle class="loading"></app-loading-circle>
			</div>
			
		</form>
		<div class="login-content__divider">
			<span>{{ 'header.login.text.or' | ibeadmin:'sync'}}</span>
		</div>
		<div class="login-content__social" (click)="INDRA_submitGLogin()">
			<app-svg svg="sprite.svg#color_icon--google_logo" ng-reflect-svg="sprite.svg#color_icon--google_logo"></app-svg>
			<p>Google</p>
		</div>
	</div>
	<div class="login-footer">
		{{ 'header.text.noAccount' | ibeadmin | async }}. <a class="text-link link--external" href="https://www.flytap.com/sign-up" target="_blank"  aria-label="Create an account on a new dialog">{{ 'header.text.createAccount' | ibeadmin | async }}.</a>
	</div>
</div>
